import React from 'react'
import './application-modal-2024.css'
import { MdCheck, MdClose, MdMoreVert } from 'react-icons/md'
import DropdownWithImage from '../DanitComponents/Dropdown/DropdownWithImage/DropdownWithImage'
import { modalOwnerOptions, modalSchoolOptions } from '../StudentOnboardingFall2023/student-onboarding-fall-2023-info'

const ApplicationModal2024 = ({setApplication, application, deleteApplication, toggleLoadingScreen, setError, pushItem}) => {
    console.log(application)
    const details = [
        {label: 'Email', value: `${application.key3app}`},
        {label: 'Areas', value: `${application.key22app}`},
        {label: 'Experience', value: `${application.key6app} years`},
        {label: 'Home Town', value: `${application.key5app}`},
        {label: 'Instrument(s)', value: `${application.key13app.map(inst => inst.name).join(', ')}`},
        {label: 'Desired Studio Size', value: `${application.key9app} Students`}
    ]
    const checkMarkList = [
        {label: 'Background Check', value: `${application.key17app}`},
        {label: 'Has Vehicle', value: `${application.key18app}`},
        {label: 'Has Driver\'s License', value: `${application.key19app}`},
        {label: 'Previous In-Home Experience', value: `${application.key7app}`},
    ]
    return (
        <div className='application-modal-2024__wrapper'>
            <div>X</div>
            <div className='application-modal-2024'>
                <div className='application-modal-2024__header'>
                    <div className='application-modal-2024__top-header'>
                        <div className='application-modal-2024__top-header__group'>
                            <div className='application-modal-2024__top-header__type'>APPLICATION</div>
                            <div className='application-modal-2024__top-header__chip'>Career Page</div>
                        </div>
                        <MdMoreVert color='#94A3B8' size={24} />
                    </div>
                    <div className='application-modal-2024__header__applicant-name'>{application.key1app} {application.key2app}</div>
                    <div className='application-modal-2024__header__dropdown-selectors'>
                        <div className='modal-area-fall-2023__selector__admin'>
                            <DropdownWithImage options={modalOwnerOptions}  />
                        </div>
                        <div className='modal-area-fall-2023__selector__admin'>
                            <DropdownWithImage options={modalSchoolOptions} />
                        </div>
                    </div>
                </div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>DETAILS</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__detail__wrapper'>
                    {details.map(detail => (
                        <div className='application-modal-2024__detail'>
                            <div className='application-modal-2024__detail__label'>{detail.label}</div>
                            <div className='application-modal-2024__detail__value'>{detail.value}</div>
                        </div>
                    ))}
                    <div className='application-modal-2024__detail'>
                        {checkMarkList.map(check => (
                            <div className='application-modal-2024__detail__check__wrapper'>
                                {check.value === 'true' ? <MdCheck color='#14B8A6' size={24} /> : <MdClose color='red' size={24} />}
                                <div className='application-modal-2024__detail__label'>{check.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>EDUCATION</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key11app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>COVER LETTER</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key10app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>EXPERIENCE</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key12app}</div>
                <div className='application-modal-2024__section-title'>
                    <div className='application-modal-2024__section-title__line'></div>
                    <div className='application-modal-2024__section-title__word'>LINKS</div>
                    <div className='application-modal-2024__section-title__line'></div>
                </div>
                <div className='application-modal-2024__paragraph-answer'>{application.key20app}</div>
                <div>Buttons</div>
            </div>
            <div>NOTES</div>
        </div>
    )
}
export default ApplicationModal2024